import Vue from 'vue'
import i18n from '@ms/lang/i18n.js'
import { DEFAULT_ERROR_TEXT } from '@ms/config/message'
import loading from './loading.vue'
import { GAME_MESSAGE } from './config/retry-message'

const getMessage = (el, modifiers) => {
  const message = el.getAttribute('retry-message')
  if (message) {
    return message
  }
  if (modifiers.game) {
    return GAME_MESSAGE
  } else {
    return DEFAULT_ERROR_TEXT
  }
}
const getImgUrl = (el) => {
  const imgUrl = el.getAttribute('retry-img')
  const type = el.getAttribute('retry-type')
  if (imgUrl) {
    return imgUrl
  }
  if (type === 'error') {
    return require('./libs/img/network.png')
  } else {
    return require('./libs/img/error.png')
  }
}

const LoadingConstructor = Vue.extend(loading)

const retry = function () {
  window.location.reload()
}
// pageLoading组件
Vue.directive('block-loading', {
  // 绑定
  bind(el, binding) {
    el.__loadingDom = document.createElement('div')

    const retryBtnText = el.getAttribute('retry-btn-text')
    const { value, modifiers } = binding
    const imgUrl = getImgUrl(el, modifiers)
    const message = getMessage(el, modifiers)

    el.__loading = new LoadingConstructor({
      i18n,
      propsData: {
        loading: value,
        message,
        imgUrl,
        retryBtnText,
        isPage: modifiers.page // 是否使用 page loading 动画
      }
    })
  },
  inserted(el, binding, vnode) {
    const arg = binding.arg
    let retryFun = retry
    if (arg && vnode.context[arg] && typeof vnode.context[arg] === 'function') {
      retryFun = vnode.context[arg]
    }

    // 当写函数式组件时会用到
    typeof arg === 'function' && (retryFun = arg)

    let elPos = window.getComputedStyle(el)
    elPos = elPos.position
    if (elPos !== 'fixed' && elPos !== 'absolute' && elPos !== 'relative') {
      el.style.position = 'relative'
    }
    el.__retry = function () {
      retryFun.call(vnode.context)
    }
    el.appendChild(el.__loadingDom)
    el.__loading.$mount(el.__loadingDom)
    el.__loading.$on('fail', el.__retry)
  },
  // 组件更新
  componentUpdated(el, binding) {
    if (el.__loading) {
      el.__loading.loading = binding.value
      el.__loading.message = getMessage(el, binding.modifiers)
    }
  },
  // 解除绑定
  unbind(el) {
    if (el.__loading) {
      el.__loading.$destroy()
      // el.removeChild(el.__loadingDom);
      el.__loading = null
      el.__loadingDom = null
    }
  }
})
